import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxGrouping = _resolveComponent("DxGrouping")!
  const _component_DxGroupPanel = _resolveComponent("DxGroupPanel")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createBlock(_component_DxDataGrid, {
    allowColumnReordering: true,
    "data-source": _ctx.dsPreturiFurnizori,
    allowColumnResizing: true,
    columnAutoWidth: false,
    columnMinWidth: 50,
    columnResizingMode: 'nextColumn',
    "show-borders": true,
    syncLookupFilterValues: false,
    onExporting: _ctx.onExporting,
    "filter-sync-enabled": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DxFilterRow, { visible: true }),
      _createVNode(_component_DxPaging, {
        "page-size": 15,
        "page-index": 1
      }),
      _createVNode(_component_DxGrouping, { "context-menu-enabled": true }, {
        default: _withCtx(() => [
          _createVNode(_component_DxTexts, {
            "group-continued-message": "Continuat de pe pagina anterioara",
            "group-continues-message": "Continuat pe pagina urmatoare"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_DxGroupPanel, {
        visible: true,
        emptyPanelText: "Trage aici o coloana pentru a grupa datele"
      }),
      _createVNode(_component_DxLoadPanel, { enabled: true }),
      _createVNode(_component_DxSorting, { mode: "multiple" }),
      _createVNode(_component_DxStateStoring, {
        enabled: true,
        filterValue: false,
        "storage-key": "PreturiFurnizori"
      }),
      _createVNode(_component_DxColumnChooser, {
        enabled: true,
        title: "Selector coloane"
      }),
      _createVNode(_component_DxSelection, { mode: "multiple" }),
      _createVNode(_component_DxExport, {
        enabled: true,
        formats: ['pdf', 'xlsx'],
        "allow-export-selected-data": true
      }),
      _createVNode(_component_DxSearchPanel, {
        visible: true,
        width: 240,
        placeholder: "Cauta ..."
      }),
      _createVNode(_component_DxColumn, {
        caption: "Furnizor",
        "data-field": "FurnizorCUI"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxLookup, {
            "data-source": _ctx.dsParteneri,
            "display-expr": "Nume",
            "value-expr": "CUI"
          }, null, 8, ["data-source"])
        ]),
        _: 1
      }),
      _createVNode(_component_DxColumn, { "data-field": "PretIntrareValuta" }),
      _createVNode(_component_DxColumn, { "data-field": "Moneda" }),
      _createVNode(_component_DxColumn, { "data-field": "StocFurnizor" }),
      _createVNode(_component_DxColumn, { "data-field": "ProdusCod" }),
      _createVNode(_component_DxColumn, { "data-field": "Categorie" }),
      _createVNode(_component_DxColumn, { "data-field": "ProdusNume" }),
      _createVNode(_component_DxColumn, { "data-field": "Garantie" }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "PretIntrareLei"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "CursFacturareLei"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "Discount"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "PretNediscountat"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "StocEva"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "Explicatie"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "ProdusCodIntern"
      }),
      _createVNode(_component_DxColumn, {
        visible: false,
        "data-field": "TimbrulVerdeLei"
      })
    ]),
    _: 1
  }, 8, ["data-source", "onExporting"]))
}